import { useLazyExportNegativeStockXlsxQuery, useNegativeStockReportQuery } from '@/entities/reports';
import type { NegativeStockCause, NegativeStockReportRow } from '@/entities/reports';
import { ReportPage, ResponsiveTable } from '@/shared/ui';
import type { ResponsiveColumns } from '@/shared/ui';
import { formatDate } from '@/shared/lib/date';

const CAUSE_COLUMNS: ResponsiveColumns<NegativeStockCause> = [
  { title: 'Документ-причина', dataIndex: 'typeLabel', width: 200 },
  { title: 'Номер', dataIndex: 'number', width: 110 },
  { title: 'Дата', dataIndex: 'docDate', width: 110, render: (v: string) => formatDate(v) },
  { title: 'Не хватило, шт', dataIndex: 'qtyUncovered', width: 130, align: 'right' },
];

/** §13, §8.6: категории с отрицательным остатком и документы-причины — те, которым не хватило
 *  товара; сумма «не хватило» по товару равна размеру минуса. */
export function NegativeStockReportPage() {
  const { data, isFetching } = useNegativeStockReportQuery(undefined, { pollingInterval: 30_000 });
  const [exportXlsx] = useLazyExportNegativeStockXlsxQuery();

  const columns: ResponsiveColumns<NegativeStockReportRow> = [
    { title: 'Товар', dataIndex: 'categoryName' },
    { title: 'Коробок', dataIndex: 'sealedBoxes', width: 90, align: 'right' },
    { title: 'Россыпь', dataIndex: 'loosePcs', width: 90, align: 'right' },
    { title: 'Всего, шт', dataIndex: 'qtyTotal', width: 100, align: 'right' },
  ];

  return (
    <ReportPage
      title="Товары в минусе"
      columns={columns}
      data={data?.rows ?? []}
      loading={isFetching}
      rowKey="categoryId"
      expandable={{
        expandedRowRender: (r) => <ResponsiveTable<NegativeStockCause> size="small" rowKey="documentId" columns={CAUSE_COLUMNS} dataSource={r.causes} pagination={false} />,
        rowExpandable: (r) => r.causes.length > 0,
      }}
      onExport={() => exportXlsx().unwrap()}
      exportFilename="Товары в минусе.xlsx"
    />
  );
}
